<template>

  <div>

    <v-row>
      <v-col cols="12" sm="5">
        <v-file-input
            label="Arquivo de seriais (.txt)"
            accept=".txt,text/plain"
            prepend-icon="mdi-file-document-outline"
            v-model="file"
            @change="lerArquivo"
            :disabled="running"
            outlined
            dense
            show-size
            ></v-file-input>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
            label="Template"
            v-model="template"
            :items="templateList"
            item-text="name"
            :disabled="running"
            return-object
            outlined
            dense
            ></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="success" @click="confirmar()" :disabled="running" block>
          <v-icon left>mdi-whatsapp</v-icon>Disparar
        </v-btn>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="primary" @click="consultar()" title="Atualizar" block>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="status">
      <v-row>
        <v-col cols="12" sm="2">
          <v-alert dense text type="info">
            {{ status.total }} contratos
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="success">
            {{ status.enviados }} enviados
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="error">
            {{ status.falhas }} falhas
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="warning">
            {{ status.semContrato }} sem contrato
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text type="warning">
            {{ status.semCelular }} sem celular
          </v-alert>
        </v-col>
        <v-col cols="12" sm="2">
          <v-alert dense text :type="running ? 'info' : 'success'">
            {{ running ? 'Processando' : 'Finalizado' }}
          </v-alert>
        </v-col>
      </v-row>
      <v-progress-linear
          :value="progresso"
          :indeterminate="running && !status.total"
          color="success"
          height="20"
          class="mb-6"
          >
        <strong>{{ processados }} / {{ status.total }}</strong>
      </v-progress-linear>
    </div>

    <v-row>
      <v-col cols="12" sm="6">
        <v-alert dense text type="info" v-if="!serials.length">
          Envie um arquivo texto com um serial por linha.
        </v-alert>
        <div v-if="serials.length">
          <v-alert dense text type="success">
            {{ serials.length }} seriais no arquivo
          </v-alert>
          <v-simple-table fixed-header height="300px">
            <thead>
              <tr>
                <th>#</th>
                <th>Serial</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(serial, index) in serials" :key="serial">
                <td>{{ index + 1 }}</td>
                <td>{{ serial }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <div v-if="template" v-html="template.content" class="wss"></div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirm" max-width="500px">
      <v-card>
        <v-card-title>Disparo de WhatsApp por serial</v-card-title>
        <v-card-text>
          <div v-if="template" v-html="template.content" class="wss"></div>
          <v-alert type="warning" dense outlined>
            Deseja enviar a mensagem para os {{ serials.length }} seriais do arquivo?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="disparar()">Disparar</v-btn>
          <v-btn color="default" @click="dialog_confirm = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    file: null,
    serials: [],
    template: null,
    status: null,
    poller: null,
    dialog_loading: false,
    dialog_confirm: false,
    templateList: [
      { name: 'suporte_alerta_vandalismo',
        content: `Prezado(a) cliente,
<br/><br/>
Informamos que nossa rede de fibra óptica sofreu um ato de vandalismo na região, o que está causando instabilidade ou interrupção no sinal de internet de alguns clientes.
<br/><br/>
🔧 Nossa equipe técnica já está no local trabalhando no reparo dos cabos rompidos e atuando para restabelecer o serviço o mais rápido possível.
<br/><br/>
Pedimos desculpas pelo transtorno e agradecemos a compreensão. Assim que o serviço for restabelecido, avisaremos por aqui.
<br/><br/>
Qualquer dúvida, estamos à disposição.
<br/><br/>
Atenciosamente,<br/>
Equipe Vivavox`
      },
      { name: 'suporte_alerta_rompimento',
        content: `Prezado(a) cliente,
<br/><br/>
Informamos que nossa rede de fibra óptica sofreu um rompimento na região, o que está causando instabilidade ou interrupção no sinal de internet de alguns clientes.
<br/><br/>
🔧 Nossa equipe técnica já está no local trabalhando no reparo dos cabos rompidos e atuando para restabelecer o serviço o mais rápido possível.
<br/><br/>
Pedimos desculpas pelo transtorno e agradecemos a compreensão. Assim que o serviço for restabelecido, avisaremos por aqui.
<br/><br/>
Qualquer dúvida, estamos à disposição.
<br/><br/>
Atenciosamente,<br/>
Equipe Vivavox`
      }
    ]
  }),
  created: function() {
    this.template = this.templateList[0];
    this.consultar();
  },
  beforeDestroy: function() {
    this.pararPolling();
  },
  computed: {
    running: function(){
      return this.status != null && this.status.running;
    },
    processados: function(){
      if(this.status==null){
        return 0;
      }
      return this.status.enviados + this.status.falhas + this.status.semContrato + this.status.semCelular;
    },
    progresso: function(){
      if(this.status==null || !this.status.total){
        return 0;
      }
      return (this.processados / this.status.total) * 100;
    }
  },
  methods: {
    lerArquivo: function(file){
      var me = this;
      me.serials = [];
      if(!file){
        return;
      }
      var reader = new FileReader();
      reader.onload = function(event){
        var lines = event.target.result.split(/\r?\n/);
        var unique = [];
        for(var i=0;i<lines.length;i++){
          var serial = lines[i].trim();
          if(serial!="" && unique.indexOf(serial)<0){
            unique.push(serial);
          }
        }
        me.serials = unique;
      };
      reader.onerror = function(){
        alert("Falha ao ler o arquivo!");
      };
      reader.readAsText(file);
    },
    consultar: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/disparo", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.status = response.data;
        if(me.running){
          me.iniciarPolling();
        }else{
          me.pararPolling();
        }
      })
      .catch(function(error) {
        me.pararPolling();
        console.log(error);
      });
    },
    iniciarPolling: function(){
      var me = this;
      if(me.poller!=null){
        return;
      }
      me.poller = setInterval(function(){
        me.consultar();
      }, 5000);
    },
    pararPolling: function(){
      if(this.poller!=null){
        clearInterval(this.poller);
        this.poller = null;
      }
    },
    confirmar: function(){
      var me = this;
      if(me.file==null || me.serials.length==0){
        alert('Envie um arquivo com pelo menos um serial.');
        return;
      }
      if(me.template==null){
        alert('Selecione o template.');
        return;
      }
      me.dialog_confirm = true;
    },
    disparar: function(){
      var me = this;
      var token = localStorage.getItem("token");
      var form = new FormData();
      form.append("file", me.file);
      form.append("template", me.template.name);
      me.dialog_confirm = false;
      me.dialog_loading = true;
      api.post("/internet/disparo", form, {headers: { Authorization: "Bearer " + token, "Content-Type": "multipart/form-data" }})
      .then(function(response) {
        me.dialog_loading = false;
        me.status = response.data;
        if(me.running){
          me.iniciarPolling();
          alert("Disparo iniciado com sucesso!");
        }else{
          alert("Já existe um disparo em andamento ou o processamento não foi iniciado!");
        }
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao disparar mensagens!");
      });
    }
  }
}

</script>

<style lang="css">
.wss {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  background-color: rgb(196, 248, 212);
  margin-bottom: 32px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  color: black;
}
</style>
